import type { FC } from "react";
import { RenderIcon } from "src/assets/icons";
import { cn } from "src/util/cn";

type LoadingProps = {
  type?: "absolute" | "block";
  className?: string;
  label?: string;
};

const Loading: FC<LoadingProps> = ({
  type = "absolute",
  className,
  label = "loading",
}) => (
  <div
    className={cn(
      "loading-component z-[999999999999]",
      type === "absolute" &&
        "absolute w-full h-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center bg-[#0B0B0BCC]",
      type === "block" && "flex items-center justify-center",
      className
    )}
  >
    <div className="flex gap-1.5 items-center">
      <RenderIcon
        width={8}
        height={8}
        className="text-green animate-pulse mb-0.5"
        color="white"
        type="circle"
      />
      <p className="text-xs loading-ellipsis m-0 ">{label}</p>
    </div>
  </div>
);

export default Loading;
